// extracted by mini-css-extract-plugin
export default {"wrapper":"view_wrapper__TJ+0G","detailsWrapper":"view_detailsWrapper__QNbYc","detailsPanel":"view_detailsPanel__urVzu"};